import InvestmentAccountPage from "./InvestmentAccountPage"

export default InvestmentAccountPage
